export default __webpack_public_path__ + "static/media/sampleFabric7.d41b26b3.jpg";